import { useNotify, useRefresh, useRecordContext } from 'react-admin';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import { request } from '../../services/request';
import { useOktaAuth } from '../../security/OktaContext';

const PREFIX = 'SoftRejectButton';

const classes = {
  softRejectButton: `${PREFIX}-softRejectButton`,
  softRejectIcon: `${PREFIX}-softRejectIcon`,
};

const StyledTooltip = styled(Tooltip)(({ theme }) => ({
  [`& .${classes.softRejectButton}`]: {
    color: '#f44336',
    zIndex: 3000,
    marginLeft: theme.spacing(1),
  },

  [`& .${classes.softRejectIcon}`]: {
    fontSize: 20,
    marginRight: theme.spacing(0.5),
  },
}));

const apiUrl = `${import.meta.env.VITE_API_URL}/v1`;

const SoftRejectButton = (props) => {
  const { oktaAuth } = useOktaAuth();
  const record = useRecordContext();
  const refresh = useRefresh();
  const notify = useNotify();

  const handleClick = async () => {
    const published = false;
    const rejected = true;
    const updatedRecord = { ...record, rejected, published };
    const requestUrl = `${apiUrl}/queues/soft-reject/${record.id}`;
    const AuthorizationString = `Bearer ${oktaAuth.getAccessToken()}`;

    const requestOptions = {
      url: requestUrl,
      method: 'put',
      headers: {
        Accept: 'application/json',
        Authorization: AuthorizationString,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(updatedRecord),
    };

    try {
      await request(requestOptions);
      refresh();
      notify('Post softly rejected', { type: 'success' });
    } catch (err) {
      notify(err.errorData.message, { type: 'warning' });
    }
  };

  return (
    <StyledTooltip title="Reject posts without sending any email notifications">
      <Button size="small" onClick={handleClick} className={classes.softRejectButton}>
        <DeleteIcon className={classes.softRejectIcon} />
        Soft Reject
      </Button>
    </StyledTooltip>
  );
};

export default SoftRejectButton;
